import { useQuery } from '@tanstack/react-query';
import { useUserIdentityState } from '@provider/user-identity';
import { HOURS_TO_MS, DAYS_TO_MS } from '@utils/constants';
import { getCoWorkersRequest } from './request.get-co-workers.js';

const getCoWorkersQueryKey = (user) => [
  "course-builder/get-co-workers",
  user == null ? void 0 : user.id
];
const getCoWorkersQuery = (user) => {
  return {
    queryKey: getCoWorkersQueryKey(user),
    queryFn: () => getCoWorkersRequest(user),
    staleTime: 8 * HOURS_TO_MS,
    gcTime: 7 * DAYS_TO_MS
  };
};
const useGetCoWorkersQuery = () => {
  const user = useUserIdentityState((state) => state.user);
  return useQuery(getCoWorkersQuery(user));
};

export { getCoWorkersQuery, getCoWorkersQueryKey, useGetCoWorkersQuery };
//# sourceMappingURL=query.get-co-workers.js.map
